export function addFormValidation(form, fieldsRequired) {

	fieldsRequired.forEach((fieldCode) => {
		let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
		if (!fieldElement) return;

		if (fieldElement.type === 'checkbox') {
			fieldElement.addEventListener('change', onCheckboxChecked);
		}
		else {
			fieldElement.addEventListener('input', onFieldInput);
		}
	});


	form.addEventListener('submit', (e) => {
		doFormValidation(form, fieldsRequired, e);
	});
}

export function doFormValidation(form, fieldsRequired, e) {
	let hasErrors = false;
	let formData = new FormData(form);

	fieldsRequired.forEach((fieldCode) => {
		let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
		if (!fieldElement) return;

		removeError(fieldElement);

		if (!formData.get(fieldCode) || !formData.get(fieldCode).length) {
			hasErrors = true;
			addError(fieldElement);
		}
	});

	if (hasErrors) {
		e.preventDefault();
	}

	return hasErrors === false;
}

export function doDateFieldValidation(form, fieldCode, e) {
	let hasErrors = false;
	let formData = new FormData(form);

	let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
	if (!fieldElement) return;

	removeError(fieldElement);

	if (!formData.get(fieldCode) || !formData.get(fieldCode).length) {
		hasErrors = true;
		addError(fieldElement);
	}

	if (!fieldElement.dateMask || fieldElement.dateMask.typedValue === null) {
		hasErrors = true;
		addError(fieldElement);
	}

	if (hasErrors) {
		e.preventDefault();
	}

	return hasErrors === false;
}

export function doPhoneFieldValidation(form, fieldCode, e) {
	let hasErrors = false;
	let formData = new FormData(form);

	let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
	if (!fieldElement) return;

	removeError(fieldElement);

	if (!formData.get(fieldCode) || !formData.get(fieldCode).length) {
		hasErrors = true;
		addError(fieldElement);
	}

	if (!fieldElement.mask || fieldElement.mask.unmaskedValue.length !== 11) {
		hasErrors = true;
		addError(fieldElement);
	}

	if (hasErrors) {
		e.preventDefault();
	}

	return hasErrors === false;
}

export function onFieldInput(e) {
	let elem = e.target;
	if (elem.value !== '') {
		removeError(elem);
	}
}

export function onCheckboxChecked(e) {
	let elem = e.target;
	if (elem.checked) {
		removeError(elem);
	}
}

export function onSelectChange(e) {
	let elem = e.target;
	if (elem.value !== '') {
		removeError(elem);
	}
}

export function removeError(elem) {
	if (elem.classList.contains('is-error')) {
		elem.classList.remove('is-error');
		
		let fieldBlock = elem.closest('.form__field');
		if (fieldBlock) {
			fieldBlock.classList.remove('field-has-error');
			fieldBlock.querySelector('.form__notice-message').remove();
		}
	}
}

export function addError(
	elem,
	message = 'Заполните поле'
)
{
	if (!elem.classList.contains('is-error')) {
		elem.classList.add('is-error');

		let fieldBlock = elem.closest('.form__field');
		if (fieldBlock) {
			fieldBlock.classList.add('field-has-error');
			fieldBlock.insertAdjacentHTML(
				'beforeend',
				`<span class="form__notice-message">${message}</span>`
			);
		}
	}
}

export function scrollToFirstError(form, offsetTop = 0) {
	let targetTop = null;
	let errorField = form.querySelector('.field-has-error');

	if (errorField) {
		let errorFieldBox = errorField.getBoundingClientRect();
		targetTop = errorFieldBox.top + window.pageYOffset - (window.screen.width >= 768 ? 81 : 72) - offsetTop;
	}

	if (targetTop !== null) {
		setTimeout(
			() => {
				window.scrollTo({
					left: 0,
					top: targetTop,
					behavior: "smooth"
				})
			},
			0
		);
	}
}

export function scrollElementTop(elem, offsetTop = 0) {

	let elemBox = elem.getBoundingClientRect();
	let targetTop = elemBox.top + window.pageYOffset - (window.screen.width >= 768 ? 81 : 72) - offsetTop;

	setTimeout(
		() => {
			window.scrollTo({
				left: 0,
				top: targetTop,
				behavior: "smooth"
			})
		},
		0
	);
}

export function initCustomSelect(select) {
	select.customSelect = new Choices(select, {
		loadingText: `Загружаем...`,
		itemSelectText: ``,
		searchEnabled: false,
		noResultsText: `Ничего не найдено`,
		shouldSort: false
	});
}

export function initDateInput(input) {
	input.dateMask = IMask(input, {
		mask: Date,
		lazy: false,
		min: new Date(1900, 0, 1),
	});
}

export function initPhoneInput(input) {
	input.addEventListener(`focus`, () => {
		if (input.mask) return;

		input.mask = IMask(input, {
			mask: `+{7} (000) 000-00-00`,
			lazy: false,
			placeholderChar: `_`,
		});

		if ('validateOnChange' in input.dataset) {
			input.mask.on('accept', function() {
				if (input.mask.unmaskedValue.length === 11) {
					removeError(input);
				}
			});
		}
	});
}

export function initPassportSeriesInput(input) {
	input.mask = IMask(input, {
		mask: '0000',
		lazy: false
	});
}

export function validatePassportSeriesValue(input) {
	return input.mask.unmaskedValue.length === 4;
}

export function initPassportNumberInput(input) {
	input.mask = IMask(input, {
		mask: '000000',
		lazy: false
	});
}

export function validatePassportNumberValue(input) {
	return input.mask.unmaskedValue.length === 6;
}

export function validatePasswordValue(value) {
	let containsBadCharsets = value.match(/[^a-zA-Z0-9+\-?*~|%@.]/) !== null;
	return !containsBadCharsets
		&& value.length >= 8
		&& value.match(/[a-z]/) !== null
		&& value.match(/[A-Z]/) !== null
		&& value.match(/[0-9]/) !== null;
}
